import { Alert } from '@mui/material';
import MuiSnackbar from '@mui/material/Snackbar';
import { useSnackbarContext } from '@src/main/ui/providers/snackbar/SnackbarContextProvider';
import { type FC } from 'react';

const Snackbar: FC = () => {
  const { snackbar, closeSnackbar } = useSnackbarContext();
  return (
    <MuiSnackbar
      open={!!snackbar}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={5_000}
      onClose={closeSnackbar}
    >
      <Alert onClose={closeSnackbar} severity={snackbar?.severity} sx={{ width: '100%' }}>
        {snackbar?.message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
